var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "booking-block",
      class: {
        "booking-block--check": _vm.valid,
        "booking-block--collapsed": _vm.collapsed
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "booking-block__header",
          on: {
            click: function($event) {
              _vm.collapsed = !_vm.collapsed
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "booking-block__header__icon booking-block__header__icon"
            },
            [
              _c(
                "svg",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.valid,
                      expression: "!valid"
                    }
                  ],
                  staticClass: "booking-icon booking-icon--miss",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 262.39 262.39"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M179.24,144.24l-12.72-12.73,12.72-12.73,70.19-70.2A25.16,25.16,0,1,0,213.85,13L131.5,95.34,48.81,12.65A25.16,25.16,0,1,0,13.22,48.23l69.92,69.92,12.73,12.73L83.15,143.61,13,213.81a25.16,25.16,0,1,0,35.58,35.58l82.35-82.34,82.69,82.69a25.16,25.16,0,1,0,35.58-35.58Z"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "svg",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.valid,
                      expression: "valid"
                    }
                  ],
                  staticClass: "booking-icon booking-icon--check",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 262.39 260.6"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M248.88,3.42c-13-7-29.61-2.92-37.16,9.08v0L105.62,181.3,49.94,108.64C41.73,97,24.88,93.75,12.31,101.35s-16.09,23.2-7.87,34.83c.38.54.78,1.06,1.2,1.57L91.87,250.39a27.19,27.19,0,0,0,17.47,10.21h.15A26.82,26.82,0,0,0,126,248.92L258.71,37.83C266.24,25.81,261.84,10.42,248.88,3.42Z"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "booking-block__header__text" },
            [
              _c("h2", { domProps: { textContent: _vm._s(_vm.title) } }),
              _vm._v(" "),
              _vm.subTitle
                ? _c("p", { domProps: { textContent: _vm._s(_vm.subTitle) } })
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots.header ? _vm._t("header") : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "booking-block__header__arrow" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 257.83 145.32"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M241.44,0a16.26,16.26,0,0,0-11.59,4.81L137.22,97.43l-8.29,8.3-8.3-8.3L28,4.81A16.39,16.39,0,0,0,0,16.4,16.3,16.3,0,0,0,4.81,28L117.33,140.52a16.39,16.39,0,0,0,23.18,0L253,28A16.41,16.41,0,0,0,241.44,0Z"
                  }
                })
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "transition" } }, [
        _vm.editMode
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.collapsed,
                    expression: "!collapsed"
                  }
                ],
                staticClass: "booking-block__content"
              },
              [
                _vm._t("edit"),
                _vm._v(" "),
                _vm.showSaveBtn
                  ? _c("button", {
                      staticClass: "btn btn--positive booking-block__save-btn",
                      domProps: {
                        textContent: _vm._s(_vm.translations.btn_save_and_close)
                      },
                      on: { click: _vm.onSave }
                    })
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "transition" } }, [
        !_vm.editMode
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.collapsed,
                    expression: "!collapsed"
                  }
                ],
                staticClass: "booking-block__read-only"
              },
              [
                _vm._t("view"),
                _vm._v(" "),
                _vm.showEditBtn
                  ? _c("button", {
                      staticClass: "btn booking-block__edit-btn",
                      domProps: {
                        textContent: _vm._s(_vm.translations.btn_edit)
                      },
                      on: { click: _vm.onEdit }
                    })
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "transition" } }, [
        _vm.$slots.footer
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.collapsed,
                    expression: "!collapsed"
                  }
                ],
                staticClass: "booking-block__footer"
              },
              [_vm._t("footer")],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-727ed3dc", { render: render, staticRenderFns: staticRenderFns })
  }
}